var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg24Home(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 11.8472C3 10.9903 3.36644 10.1743 4.00691 9.60497L10.6713 3.68109C11.429 3.00752 12.571 3.00752 13.3287 3.68109L19.9931 9.60497C20.6336 10.1743 21 10.9903 21 11.8472V18.5C21 19.6046 20.1046 20.5 19 20.5H5C3.89543 20.5 3 19.6046 3 18.5V11.8472Z",
    fill: "#A4ACB8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg24Home);
export default __webpack_public_path__ + "static/media/24_Home.eee860f5d46c5800f84dc868d8d99a15.svg";
export { ForwardRef as ReactComponent };